import axios from 'axios'
import { protocol } from '@/config'
export default {
  getRedirect: data => axios.post(`${protocol}//mall.xueersi.com/cs/trans`, data)
}



// WEBPACK FOOTER //
// ./src/networks/api/RedirectOld/index.js